import { render, staticRenderFns } from "./ModalDuplicateDesign.vue?vue&type=template&id=434273bc&scoped=true"
import script from "./ModalDuplicateDesign.vue?vue&type=script&lang=js"
export * from "./ModalDuplicateDesign.vue?vue&type=script&lang=js"
import style0 from "./ModalDuplicateDesign.vue?vue&type=style&index=0&id=434273bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434273bc",
  null
  
)

export default component.exports